const ignoreParas = [
  // See: EGWW-4249
  "14748.2",
  "14749.2",
  "14750.2117",
  "14752.2",
  "14753.2",
];

const getRealFirstChapter = (toc) => {
  let firstChapterIndex = 0;
  if (toc[firstChapterIndex].para_id.split(".")[1] === "0" && toc[firstChapterIndex + 1]) {
    firstChapterIndex++;
  }

  if (ignoreParas.indexOf(toc[firstChapterIndex].para_id) > -1 && toc[firstChapterIndex + 1]) {
    firstChapterIndex++;
  }

  if (toc[firstChapterIndex].level === 0 && toc[firstChapterIndex + 1]) {
    firstChapterIndex++;
  }


  return firstChapterIndex;
};

export const makeBookInfoChapterObject = (book, toc) => {
  const firstChapterIndex = getRealFirstChapter(toc);

  return {
    book,
    isBookInfo: true,
    para_id: book.book_id + ".0",
    id_prev: null,
    id_next: toc[firstChapterIndex].para_id,
    content: "",
    translations: [],
  };
};

export const makeBookInfoTocObject = (chapterId, toc) => {
  const firstChapterIndex = getRealFirstChapter(toc);
  const id = String(chapterId).split(".")[0] + ".0";

  return {
    para_id: id,
    level: toc[firstChapterIndex].level,
    isBookInfo: true,
    title: "About book",
    refcode_short: "",
    dup: "",
    mp3: null,
    puborder: toc[firstChapterIndex].puborder - 1,
    className: "chapter",
    id,
    cursor: 0,
  };
};

// Specific navigation: Skips chapters without paragraphs.
export const diveToChapterWithContent = (chapterId, toc) => {
  let chapter = null;
  let index = -1;

  if (toc && chapterId) {
    index = toc.findIndex((item) => chapterId === item.id);

    if (toc[index] && ignoreParas.indexOf(toc[index].para_id) > -1 && toc[index + 1]) {
      index += 1;
    }

    if (index !== -1) {
      if (chapterId.split(".")[1] === "0") {
        return {
          chapter: makeBookInfoTocObject(chapterId, toc),
          index: 0,
        };
      }

      const chapterObj = goInDirectionWithSkipChaptersTitles(toc, index, true);
      if (chapterObj.chapter) {
        chapter = chapterObj.chapter;
        index = chapterObj.index;
      }
    }

    if (index === -1) {
      // The reinsurance code for cases, when user manually opens a link
      // with an id like "xxx.1"
      // (Note, ".1" it means to open a first chapter, not a chapter with index "1")
      if (chapterId.split(".")[1] === "1") {
        if (toc[1] || toc[0]) {
          index = toc[1] ? 1 : 0;
          chapter = toc[index];
        }
      }

      if (chapterId.split(".")[1] === "0") {
        index = 0;
        chapter = makeBookInfoTocObject(chapterId, toc);
      }
    }
  }

  return {
    chapter,
    index,
  };
};

// Specific navigation: Skips chapters without paragraphs.
export const getTocChaptersPrevNextCurr = (chapterId, toc) => {
  let currChapterObj,
    currChapter = null,
    prevChapter = null,
    nextChapter = null;

  if (toc) {
    currChapterObj = diveToChapterWithContent(chapterId, toc);

    if (currChapterObj && currChapterObj.index !== -1) {
      currChapter = currChapterObj.chapter;

      const currChapterHighestParent = goInDirectionWithSkipChaptersTitles(
        toc,
        currChapterObj.index,
        false
      );
      if (
        toc[currChapterHighestParent.index - 1] &&
        toc[currChapterHighestParent.index - 1].level !== 0
      ) {
        prevChapter = toc[currChapterHighestParent.index - 1];
      }
      // Always skip the title chapter - it's an exception.
      if (prevChapter && prevChapter.level === 0) {
        prevChapter = null;
      }
      // ==============================================

      const nextChapterObject = goInDirectionWithSkipChaptersTitles(
        toc,
        currChapterObj.index + 1,
        true
      );
      if (nextChapterObject.chapter) {
        nextChapter = nextChapterObject.chapter;
      }
    }

    if (currChapterObj && currChapterObj.index !== 0) {
      currChapter = currChapterObj.chapter;

      const nextChapterObject = goInDirectionWithSkipChaptersTitles(
        toc,
        currChapterObj.index + 1,
        true
      );
      if (nextChapterObject.chapter) {
        nextChapter = nextChapterObject.chapter;
      }
    }
  }

  return {
    currChapter,
    prevChapter,
    nextChapter,
  };
};

// Specific navigation: Skips chapters without paragraphs.
const goInDirectionWithSkipChaptersTitles = (toc, index, isForward) => {
  let indexNew = index;
  let chapterNew = toc[indexNew];

  while (
    isForward
      ? toc[indexNew + 1] &&
        (toc[indexNew + 1].puborder - chapterNew.puborder === 1 ||
          toc[indexNew + 1].dup === chapterNew.id ||
          ignoreParas.indexOf(chapterNew.id) > -1)
      : toc[indexNew - 1] &&
        (chapterNew.puborder - toc[indexNew - 1].puborder === 1 ||
          toc[indexNew - 1].id === chapterNew.dup ||
          ignoreParas.indexOf(chapterNew.id) > -1)
  ) {
    if (isForward) {
      indexNew = indexNew + 1;
    } else {
      indexNew = indexNew - 1;
    }
    chapterNew = toc[indexNew];
  }

  return { chapter: chapterNew || null, index: chapterNew ? indexNew : -1 };
};

// e.g. of the case
// requested a random para id of the chapter, fetch chapter content to get actual {chapterId}
// Actual {chapterId} is needed to detect possible chapter that could be skipped.
// "Title" chapter and "Parent of a Branch" chapters should be skipped, because they
// have little amount of paragraphs.
export const getChapterByParaId = (toc, paraId, fnFetchChapterContent) => {
  let chapterObj = diveToChapterWithContent(paraId, toc);

  if (chapterObj.index === -1) {
    const chapterContentOrPromise = fnFetchChapterContent(paraId);

    const handleChapterContent = (chapterContent) => {
      if (chapterContent && chapterContent[0]) {
        const chapterCurrentFixed = diveToChapterWithContent(chapterContent[0].para_id, toc);

        if (chapterCurrentFixed.index !== -1) {
          return chapterCurrentFixed;
        }
      }

      return chapterObj;
    };

    if (chapterContentOrPromise instanceof Promise) {
      return chapterContentOrPromise.then(handleChapterContent);
    }

    return handleChapterContent(chapterContentOrPromise);
  }

  return chapterObj;
};
